import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { ConfigProvider } from '../../providers/config/config';
import { TranslateService } from '@ngx-translate/core';
import { InstituicaoProvider } from '../../providers/instituicao/instituicao';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  formatted: any;
  ddiNovo: string = '';
  constructor(
    public configProvider: ConfigProvider,
    private translate: TranslateService,
    public instituicaoProvider: InstituicaoProvider,
  ) {}

  transform(phoneValue: number | string, ddi: string) {
    return this.configProvider.getMaskTelApp().then((mask) => {
      if (phoneValue) {
        this.ddiNovo = ddi ? ddi : '+55';
        const formatDdi = this.instituicaoProvider.objDddi()[this.ddiNovo];
        const stringPhone = phoneValue.toString();
        const phoneNumber = parsePhoneNumberFromString(stringPhone, formatDdi);

        if (phoneNumber) {
          this.formatted =
            this.ddiNovo === '+55' ? '+55 ' + phoneNumber.formatNational() : phoneNumber.formatInternational();
        } else {
          return this.ddiNovo + stringPhone;
        }

        return this.formatted;
      } else {
        return this.translate.instant('Não Informado');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/phone/phone.ts